document.addEventListener('DOMContentLoaded', function() {
  function closeCartDrawer() {
    const cartDrawer = document.querySelector('.scd__wrapper');
    const cartDrawerContent = document.querySelector('.scd__content');
    
    if (cartDrawer && cartDrawerContent) {
      cartDrawer.style.setProperty('--tw-bg-opacity', '0');
      cartDrawerContent.classList.add('translate-x-full');
      
      setTimeout(() => {
        cartDrawer.classList.add('hidden');
        cartDrawer.classList.remove('mobile');
        document.documentElement.classList.remove('prevent-scroll');
      }, 300);
    }
  }

  const cartDrawerClose = document.querySelector('.scd__close');
  if (cartDrawerClose) {
    cartDrawerClose.addEventListener('click', function(e) {
      e.preventDefault();
      closeCartDrawer();
    });
  }

  const cartDrawer = document.querySelector('.scd__wrapper');
  if (cartDrawer) {
    cartDrawer.addEventListener('click', function(e) {
      if (e.target === cartDrawer) {
        closeCartDrawer();
      }
    });
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const cartDrawer = document.querySelector('.scd__wrapper');
      if (cartDrawer && !cartDrawer.classList.contains('hidden')) {
        closeCartDrawer();
      }
    }
  });
}); 